import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

const $ = require('jquery');
window.$ = $;

createApp(App).use(router).mount('#app')
// createApp(App).mount('#app')
